import GetNetView from "./Views/Financeiro/Titulo/Pagamento/GetNetView";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import { AppAreaRestrita } from "./AreaRestritta/AppAreaRestrita";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { DefaultQueryClientConfig } from "./Defaults";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import AppAdministracao from "./App";
import PagamentoSucesso from "./Views/Financeiro/Titulo/Pagamento/PagamentoSucesso";

import "./Styles/App.css";
import { Documentos } from "./Documentos";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const Aplicacao = (): JSX.Element => {
    if (window.location.pathname.startsWith("/area-restrita")) {
        return <AppAreaRestrita />;
    }

    if (window.location.pathname.startsWith("/docs")) {
        return (
            <BrowserRouter basename="/docs">
                <Routes>
                    <Route index path=":token?" 
                        element={ <QueryClientProvider client={new QueryClient({...DefaultQueryClientConfig})}> <Documentos /> </QueryClientProvider> }
                    />
                </Routes>
            </BrowserRouter>
        );
    }

    if (window.location.pathname.startsWith("/Financeiro/Pagamento")) {
        const queryClient = new QueryClient({ ...DefaultQueryClientConfig });

        return (
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/Financeiro/Pagamento" element={<GetNetView />}></Route>
                        <Route path="/Financeiro/Pagamento/Sucesso" element={<PagamentoSucesso />}></Route>
                    </Routes>
                </BrowserRouter>
            </QueryClientProvider>
        );
    }

    return (
        <>
            <AppAdministracao />
        </>
    );
};

root.render(
    // <React.StrictMode>
    <Aplicacao />
    // </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
